import { useEffect, useState } from "react";

const MAX_TIMEOUT_MS = 2 ** 31 - 1;

/**
 * Re-renders the caller when the soonest future instant in `instants` passes,
 * so lists can re-evaluate time-based state (e.g. a link that expires while
 * the page is open). Returns the current time for that render.
 */
export function useExpiryTick(instants: ReadonlyArray<string | null | undefined>): number {
  const [tick, setTick] = useState(0);
  const now = Date.now();
  let next = Number.POSITIVE_INFINITY;
  for (const iso of instants) {
    if (!iso) continue;
    const at = new Date(iso).getTime();
    if (at > now && at < next) next = at;
  }
  const target = Number.isFinite(next) ? next : null;
  // biome-ignore lint/correctness/useExhaustiveDependencies: `tick` re-arms after each boundary or a capped wait.
  useEffect(() => {
    if (target === null) return;
    const id = setTimeout(() => setTick((n) => n + 1), Math.min(target - Date.now() + 50, MAX_TIMEOUT_MS));
    return () => clearTimeout(id);
  }, [target, tick]);
  return now;
}
